import type { PropsWithChildren } from "react";

import { StyledFilterButtonLabel } from "./styles";

type Props = PropsWithChildren<{
    className?: string;
}>;

const JobPositionButtonLabel = ({ children, className }: Props) => {
    return (
        <StyledFilterButtonLabel
            className={className}
            data-automation="button-label"
        >
            {children}
        </StyledFilterButtonLabel>
    );
};

export default JobPositionButtonLabel;
